module.exports = __webpack_public_path__ + "static/media/sa5.8eb0e4f9.jpg";